import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const QuoteStartIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'defaultColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g data-testid="icon-quoteStart" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path
          d="M12.59375,16.0529412 C14.40625,16.0529412 15.84375,14.7872211 15.84375,12.9048682 C15.84375,11.2172414 14.8125,10.2111562 13.375,9.85415822 L12.0625,9.85415822 C12.21875,8.036714 13.78125,6.31663286 16,5.99208925 L16,5.7 C12.3125,5.82981744 9,8.23144016 9,11.8663286 C9,14.3004057 10.40625,16.0529412 12.59375,16.0529412 Z M3.86554622,16.0529412 C5.81512605,16.0529412 7.36134454,14.7872211 7.36134454,12.9048682 C7.36134454,11.2172414 6.25210084,10.2111562 4.70588235,9.85415822 L3.29411765,9.85415822 C3.46218487,8.036714 5.14285714,6.31663286 7.52941176,5.99208925 L7.52941176,5.7 C3.56302521,5.82981744 0,8.23144016 0,11.8663286 C0,14.3004057 1.51260504,16.0529412 3.86554622,16.0529412 Z"
          fill={customColour}
          className={styles[className]}
        />
      </g>
    </Icon>
  )
}
